"use client";

import {
  AudioBufferSource,
  BufferTarget,
  OggOutputFormat,
  Output,
} from "mediabunny";

import { AudioTargetFormat } from "@/utils/audio/types";

export const audioBufferToOpus = async ({
  audioBuffer,
  targetFormat,
  bitrate,
}: {
  audioBuffer: AudioBuffer;
  targetFormat: AudioTargetFormat;
  bitrate: number;
}): Promise<Blob> => {
  const output = new Output({
    format: new OggOutputFormat(),
    target: new BufferTarget(),
  });

  const audioSource = new AudioBufferSource({
    codec: "opus",
    bitrate,
    ...(targetFormat === null ? {} : { transform: targetFormat }),
  });

  output.addAudioTrack(audioSource);
  await output.start();
  await audioSource.add(audioBuffer);
  await output.finalize();

  const buffer = output.target.buffer;
  if (buffer === null) {
    throw new Error("Opus encoding produced no output");
  }
  return new Blob([buffer], { type: "audio/ogg" });
};
